export const whitelistedEndpoints = [
	'https://sled.wix.dev/',
	'https://bo.wix.com/suricate/tunnel/',
	'https://localhost:',
	'http://localhost:',
]
